module.exports = __webpack_public_path__ + "img/logo.08908478.png";